import { Countries } from '../../../i18n';
import { CountryCodes, ICountryCode } from '../../../i18n/CountryCodes';

const parse = (startPhone?: string, country?: string) => {
    if (country !== undefined && country !== null) {
        const countryFound: ICountryCode | undefined = CountryCodes.find(
            (c) =>
                c.name === country || c.name_fr === country || c.name_en === country || c.code === country.toUpperCase()
        );
        if (countryFound) {
            return countryFound.code.toLowerCase();
        }
    }

    if (startPhone !== undefined) {
        const currentCountry = CountryCodes.find((c) => c.dial_code === startPhone);
        if (currentCountry) {
            return currentCountry.code.toLowerCase();
        }
    }

    return Countries.France.toLowerCase();
};

export type CountryCodeParser = {
    parse: (startPhone?: string, country?: string) => string;
};

export const countryCodeParser = (): CountryCodeParser => {
    return { parse };
};
